import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const ASSETS_ASSET_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/assets',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:Assets',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.Assets',
      },
    ]);
  };
}
